<template>
    <div>
        <modal :show.sync="show" :large="true">
            <div class="modal-header"
                 slot="modal-header">
                <h4>Sélectionner les contacts à conserver</h4>
            </div>

            <div class="modal-body" slot="modal-body">
                <div class="contact-selection" v-if="!loading">
                    <div class="row equal" >
                        <div v-for="(listName, list) in dndContacts"
                             class="col-md-3 contact-box"
                             track-by="$index">
                            <div class="panel panel-vue panel-default">
                                <div
                                    v-if="list.names && list.names.length === 0
                                    && listName !== 0"
                                    class="panel-heading"
                                    v-dnd-draggable
                                    dnd-drop="droppedToContact"
                                    v-dnd-list
                                    :dnd-horizontal-list="false"
                                    dnd-type="contact"
                                    :dnd-list="dndContacts"
                                    :dnd-draggable="list"
                                    :dnd-index="listName"
                                    :dnd-data="dndContacts"
                                >
                                    <span class="panel-heading">
                                        {{ list.title | shortTitle }}
                                        {{ list.first_name }}
                                        {{ list.last_name }}
                                        <i class="fa fa-pencil edit-pencil"></i>
                                    </span>
                                </div>
                                <div
                                    v-for="(pos, name) in list.names"
                                    class="panel-heading"
                                    dnd-drop="droppedToContact"
                                    v-dnd-draggable
                                    v-dnd-list
                                    :dnd-horizontal-list="false"
                                    dnd-type="name"
                                    :dnd-list="list.names"
                                    :dnd-draggable="name"
                                    :dnd-index-in-list="pos"
                                    :dnd-index="listName"
                                    :dnd-data="list.names"
                                >
                                    <span class="panel-heading">
                                        {{ name.title | shortTitle }}
                                        {{ name.first_name }}
                                        {{ name.last_name }}
                                        <i class="fa fa-pencil edit-pencil"></i>
                                    </span>
                                </div>
                                <div class="panel-body list-group">
                                    <div class="list-group-item dnd-zone"
                                         v-dnd-list :dnd-list="list.infos"
                                         :dnd-index="listName"
                                         dnd-drop="droppedToContact"
                                         :dnd-horizontal-list="false">
                                        <a v-dnd-draggable
                                           v-for="item in list.infos"
                                           v-bind:class="{
                                               '-phone': item.type === 'phone',
                                               '-address': item.type === 'address',
                                               '-email': item.type === 'email'
                                           }"
                                           dnd-type="item"
                                           :dnd-draggable="item"
                                           :dnd-index="listName"
                                           :dnd-data="list.infos"
                                           dnd-effect-allowed="move"
                                           v-bind:href="generateHref(item)"
                                        >
                                            <i class="glyphicon"
                                               v-bind:class="{
                                                'glyphicon-earphone': item.type === 'phone',
                                                'glyphicon-envelope': item.type === 'email',
                                                'glyphicon-home': item.type === 'address'
                                            }"
                                            ></i>
                                            <span>
                                                {{{autoFilter(item)}}}
                                            </span>
                                        </a>
                                        <li class="dndPlaceholder red"></li>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 contact-box" id="trash">
                            <div class="panel panel-vue panel-default">
                                <div class="panel-heading">
                                    <span>
                                        Element à supprimer
                                    </span>
                                </div>
                                <div class="panel-body list-group">
                                    <div class="list-group-item dnd-zone"
                                         v-dnd-draggable
                                         v-dnd-list
                                         dnd-drop="droppedToTrash"
                                         dnd-type="item"
                                         :dnd-list="dndContacts[0]"
                                         :dnd-index="$index"
                                         :dnd-data="dndContacts[0]"
                                         :dnd-horizontal-list="false">
                                        <a v-dnd-draggable
                                           dnd-type="item"
                                           v-for="item in dndContacts[0]"
                                           v-bind:class="{
                                        '-phone': item.type === 'phone',
                                        '-address': item.type === 'address',
                                        '-email': item.type === 'email'
                                   }"
                                           :dnd-draggable="item"
                                           :dnd-index="$index"
                                           :dnd-data="dndContacts[0]"
                                           :dnd-allowed-types="['item']"
                                        >
                                    <span>
                                        <i class="glyphicon"
                                           v-bind:class="{
                                                'glyphicon-earphone': item.type === 'phone',
                                                'glyphicon-envelope': item.type === 'email',
                                                'glyphicon-home': item.type === 'address'
                                            }"
                                        ></i>
                                    </span>
                                            {{{autoFilter(item)}}}
                                        </a>

                                    </div>
                                </div>
                                <div v-for="(listName, list) in dndContacts[0]" >
                                    <div v-if="list.infos.length > 0"
                                         class="panel panel-vue panel-default"
                                    >
                                        <div
                                            class="panel-heading"
                                            v-dnd-draggable
                                            dnd-type="contact"
                                            :dnd-list="dndContacts"
                                            :dnd-draggable="list"
                                            :dnd-index="0"
                                            :dnd-data="dndContacts"
                                        >
                                            {{ list.title | shortTitle }}
                                            {{ list.first_name }}
                                            {{ list.last_name }}
                                            <i class="fa fa-pencil edit-pencil"></i>
                                        </div>
                                        <div class="panel-body list-group">
                                            <div class="list-group-item dnd-zone"
                                                 dnd-type="contact"
                                                 :dnd-horizontal-list="false">
                                                <a v-dnd-draggable
                                                   v-for="item in list.infos"
                                                   v-bind:class="{
                                               '-phone': item.type === 'phone',
                                               '-address': item.type === 'address',
                                               '-email': item.type === 'email'
                                           }"
                                                   dnd-type="item"
                                                   :dnd-draggable="item"
                                                   :dnd-index="$index"
                                                   :dnd-data="list.infos"
                                                   v-bind:href="generateHref(item)"
                                                >
                                                    <i class="glyphicon"
                                                       v-bind:class="{
                                                'glyphicon-earphone': item.type === 'phone',
                                                'glyphicon-envelope': item.type === 'email',
                                                'glyphicon-home': item.type === 'address'
                                            }"
                                                    ></i>
                                                    <span>
                                                {{{autoFilter(item)}}}
                                            </span>
                                                </a>
                                                <li class="dndPlaceholder red"></li>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div
                                         v-for="(listName, list) in dndContacts[0]"
                                    >
                                        <div
                                            class="panel panel-vue panel-default"
                                            v-if="typeof list.last_name !== 'undefined'
                                        && typeof list.infos === 'undefined'"
                                        >
                                            <div
                                                class="panel-heading"
                                                v-dnd-draggable
                                                dnd-type="name"
                                                :dnd-index="$index"
                                                :dnd-data="dndContacts[0]"
                                            >
                                                <span
                                                    class="panel-heading">
                                                    {{ list.title | shortTitle }}
                                                    {{ list.first_name }}
                                                    {{ list.last_name }}
                                                </span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <loader v-if="loading"></loader>
            </div>

            <div slot="modal-footer" class="modal-footer cta">
                <a class="btn btn-default"
                   @click.prevent="show = false">
                    Annuler
                </a>
                <a class="btn btn-primary" id="confirm-merge"
                   @click.prevent="validate">
                    Valider
                </a>
            </div>
        </modal>
    </div>
</template>

<style lang="less" type="text/less">
    .modal-body {
        max-height: calc(100vh - 30px);
        overflow-y: auto;
    }
    .contact-selection {
        .list-group-item {
            a {
                word-break: break-all;
            }
            li {
                height: 10px;
                list-style: none;
            }
        }
    }
</style>
<style lang="less" type="text/less" scoped>
    @import '~src/style/variables';

    div[draggable] {
        cursor: move;
    }

    .contact-box {
        margin-bottom: 15px;
    }
    .row {
        // first element is an hidden trash
        .contact-box:first-child {
            display: none;
        }
    }

    a.panel-heading {
        display: block;

        &:hover {
            text-decoration: none;
        }
    }

    .edit-pencil {
        visibility: hidden;

        a:hover & {
            visibility: visible;
        }
    }
    #trash {
        .dndDragover {
            background: rgba(255,4,6,0.5);
        }
    }
    .list-group-item {
        &.dndDragover {
            background: @brand-success;
            background-clip:content-box;
        }
        padding: 0;

        > * {
            padding: 16px 24px;
        }

        .lgi-inner,
        a {
            cursor: move;
            display: flex;
            color: @text-color;
        }

        i.glyphicon {
            margin-right: 7px;
        }
    }
    tr {
        .-select-client-btn {
            visibility: hidden;
            color: #fff !important;
            text-decoration: none;
        }
        &:hover {
            .-select-client-btn {
                visibility: visible;
            }
        }
    }
    .modal-body {
        min-height: 320px;
    }
    .panel-default {
        display: inline-block;
        height: 100%;
        width: 100%;
        vertical-align: top;
    }
    .dnd-zone {
        min-height: 100px;
    }
    #trash {
        .panel-default {
            //border: 1px solid red;
        }
        height: 100%;
    }
    .equal {
        display: flex;
        display: -webkit-flex;
        flex-wrap: wrap;
    }
</style>

<script>
    import Loader from '../../components/Loader';
    import ContactBox from '../../components/clients/ContactBox';
    import Modal from 'vue-strap/src/Modal';
    import Vue from 'vue';
    import {mergeContacts, removeDuplicates} from './utils';
    import {getAddressLink} from '../../utils';

    export default {
        components: {
            Loader,
            ContactBox,
            Modal
        },
        name: 'select-contacts-modal',
        computed: {
            contacts() {
                const _contacts = [];
                this.clients.forEach(client => {
                    client.contacts.forEach(contact => _contacts.push(contact));
                });
                return _contacts;
            }
        },
        data: function () {
            return {
                list: [],
                show: false,
                loading: false,
                contracts: [],
                clients: [],
                dndContacts: {}
            };
        },
        methods: {
            /**
             * Depennding on the type of item, the method generate a mail
             * link, a tel link or a gmap link
             */
            generateHref(item) {
                if (item.type === 'phone') return `tel: ${item.value}`;
                if (item.type === 'email') return `mailto: ${item.value}`;
                if (item.type === 'address') {
                    const {formatted_address} = JSON.parse(item.value);
                    return getAddressLink(formatted_address);
                }
                return '';
            },
            /**
             * When user validate the merge, we need to reformat data and call the api
             */
            validate: function () {
                // index 0 being the trash, we remove it, then we ensure that the contact have
                // a name and some infos
                const contactsToKeep = this.dndContacts.filter((el, i) => {
                    return i > 0 && el.first_name && el.last_name && el.infos && el.infos.length;
                }).map((el) => {
                    delete el.ctIndex;
                    // if multiple names, we take the first in the array
                    if (el.names && el.names.length > 0) {
                        el.first_name = el.names[0].first_name;
                        el.last_name = el.names[0].last_name;
                        el.title = el.names[0].title;
                        delete el.names;
                    }
                    el.info = el.infos.map((info) => {
                        delete info.ctIndex;
                        delete info.id; // not sure about it
                        return info;
                    });
                    delete el.infos;
                    return el;
                });
                const clientToSave = Object.assign({}, this.clients[0]);
                const clientToRemove = this.clients[1];
                clientToSave.contacts = contactsToKeep;
                clientToSave.contracts = this.contracts;
                clientToSave.sources = ['activeseed', 'alpinia'];
                this.$dispatch('merge-client', clientToSave, clientToRemove);
                this.show = false;
            },
            /**
             * add the right vuefilter for each item. Filter can be phone or address
             */
            autoFilter(item) {
                const filter = {
                    phone: 'phone',
                    address: 'address'
                }[item.type];
                if (filter) {
                    return Vue.filter(filter)(item.value);
                }
                return item.value;
            },
            /**
             * Methods called when an element is dropped to a contact box
             * 3 types of element can be dropped into a contact box
             * name, contact and item
             * Depending on the type, the method does different things
             * Dropping a contact into an other contact will merge the 2
             * contact together
             * Dropping a name into a contact, will append the name to the
             * list of name. Only the name on the top of the list will be kept.
             * Dropping an item into a contact will move the item from the
             * previous contact to the new contact
             */
            droppedToContact: function ({event, index, item, type}) {
                const newIndex = event.currentTarget.getAttribute('dnd-index');
                const oldIndex = item.ctIndex;
                if (Number(newIndex) === Number(oldIndex)) {
                    return false;
                }
                if (type === 'name') {
                    this.dndContacts.$set(newIndex, Object.assign({
                        infos: [],
                        names: []
                    }, this.dndContacts[newIndex], item, {
                        ctIndex: newIndex
                    }));
                    // remove name from old index
                    let names = [];
                    if (oldIndex > 0) {
                        names = this.dndContacts[oldIndex].names.filter((it) => {
                            return !(item.first_name === it.first_name && item.last_name ===
                                it.last_name);
                        });
                    }
                    // if names.length = 1, clear names and set name
                    if (names.length <= 1) {
                        const oldNames = Object.assign({}, names);
                        names = [];
                        this.dndContacts.$set(oldIndex, Object.assign(
                            this.dndContacts[oldIndex],
                            {
                                names,
                                first_name: oldNames[0].first_name,
                                last_name: oldNames[0].last_name,
                                title: oldNames[0].title
                            })
                        );
                    }
                    this.dndContacts.$set(oldIndex, Object.assign(
                        this.dndContacts[oldIndex], {names}
                        )
                    );
                    return false;
                }
                if (type === 'contact') {
                    const newObj = mergeContacts(
                        item,
                        this.dndContacts[newIndex],
                        parseInt(newIndex, 10)
                    );
                    this.dndContacts.$set(newIndex, newObj);
                    // if trash
                    if (oldIndex === 0) {
                        const oldTrash = this.dndContacts[0].filter(cnt => {
                            return !(
                                cnt.first_name === item.first_name && item.last_name ===
                                item.last_name);
                        });
                        this.dndContacts.$set(oldIndex, oldTrash);
                    }
                    // if dropped into another contact
                    if (oldIndex > 0) {
                        this.dndContacts.$set(oldIndex, {infos: []});
                    }
                    return false;
                }
                if (type === 'item') {
                    // set the new ctIndex
                    const newItem = Object.assign(item, {ctIndex: newIndex});
                    this.dndContacts[newIndex].infos.push(newItem);
                    // remove the item from the previous contact
                    let newInfo = [];
                    if (oldIndex > 0) {
                        newInfo = this.dndContacts[oldIndex].infos.filter((it) => {
                            return !(item.type === it.type && item.value === it.value);
                        });
                        this.dndContacts[oldIndex].infos = newInfo;
                    }
                }
                return true;
            },
            /**
             * Methods called when an element is dropped to the trash
             * 3 types of element can be dropped into trash
             * name, contact and item
             * Depending on the type, the method does different things
             */
            droppedToTrash: function ({event, index, item, type}) {
                if (type === 'name') {
                    const newNames = this.dndContacts[item.ctIndex].names.filter((it) => {
                        return !(
                            item.last_name === it.last_name &&
                            item.first_name === it.first_name
                        );
                    });
                    this.dndContacts.$set(item.ctIndex, Object.assign({},
                        this.dndContacts[item.ctIndex],
                        {names: newNames}));
                    this.dndContacts[0].push(item);
                    return true;
                }
                if (type === 'contact') {
                    this.dndContacts.$set(item.ctIndex, { ctIndex: 0, infos: [], names: []});
                    item.infos = item.infos.map((inf) => {
                        inf.ctIndex = 0;
                        return inf;
                    });
                    item.ctIndex = 0;
                    this.dndContacts[0].push(item);
                    return false;
                }
                if (type === 'item') {
                    const newInfo = this.dndContacts[item.ctIndex].infos.filter((it) => {
                        return !(item.type === it.type && item.value === it.value);
                    });
                    const uniqNewInfo = removeDuplicates(
                        newInfo,
                        'value'
                    );
                    this.dndContacts[item.ctIndex].ctIndex = 0;
                    this.dndContacts[item.ctIndex].infos = uniqNewInfo;
                    item.ctIndex = 0;
                }
                this.dndContacts[0].push(item);
                return true;
            }
        },
        events: {
            /**
             * @param clients array of clients to merge
             * @param contracts array of contracts that should be kept
             */
            'client-merge-contacts-select': function (clients, contracts) {
                this.clients = Object.assign({}, clients);
                this.contracts = contracts;
                const dndContacts = [
                    []
                ];
                let ctIndex = 0;
                clients.forEach((cl) => {
                    cl.contacts.forEach((contact) => {
                        ctIndex += 1;
                        if (typeof dndContacts[ctIndex] === 'undefined') {
                            dndContacts[ctIndex] = {
                                names: [],
                                infos: [],
                                exchanges: clients.reduce((exchanges, c) => {
                                    c.exchanges.filter((ex) => {
                                        const ctFound = ex.contacts.filter((cont) => {
                                            return cont.id === contact.id;
                                        });
                                        if (ctFound.length > 0) {
                                            exchanges.push(ex);
                                        }
                                    });
                                    return exchanges;
                                }, []),
                                ctIndex,
                                title: contact.title,
                                first_name: contact.first_name,
                                last_name: contact.last_name
                            };
                        }
                        const info = contact.info.map((it) => {
                            it.ctIndex = ctIndex;
                            return it;
                        });
                        info.ctIndex = ctIndex;
                        dndContacts[ctIndex]['ctIndex'] = ctIndex;
                        dndContacts[ctIndex]['infos'] = info;
                    });
                });
                this.dndContacts = Object.values(Object.assign({}, dndContacts));
                this.show = true;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// SelectContactsModal.vue?ac09b870